<script>
export default {
  inheritAttrs: false,
  model: {
    event: 'update',
  },
  props: {
    labelContent: {
      type: String,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    fieldId: {
      type: String,
      default: '',
      required: false,
    },
    markRequired: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
}
</script>

<template>
  <div>
    <label :class="[$style.labelContent]" :for="fieldId">{{
      labelContent
    }}</label>
    <span v-if="markRequired" :class="$style.asteriskMark">*</span>
    <b-form-textarea
      :id="fieldId"
      rows="2"
      :class="[$style.input, $style.selectbg]"
      v-bind="$attrs"
      no-resize
      :disabled="isDisabled"
      v-on="$listeners"
      @input="$emit('update', $event)"
    >
    </b-form-textarea>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.labelContent {
  float: left;
  margin: $size-content-label-margin 0;
  font-size: $size-content-font;
  font-weight: $label-font-weight;
  color: $color-text-gray;
}
.selectbg {
  background-color: $color-content-bg;
  border: $input-border;
}
.asteriskMark {
  position: relative;
  top: 10px;
  left: 2px;
  display: flex;
  font-size: 1rem;
  color: red;
}
</style>
